import produce from 'immer';

// TYPES
import { Types, ConsultaAgendamentos } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaAgendamentos = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaAgendamentos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_AGENDAMENTOS_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.CONSULTA_AGENDAMENTOS_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CONSULTA_AGENDAMENTOS_FAILURE: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CONSULTA_AGENDAMENTOS_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
